var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMessages = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chat_bubble"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_518_108558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_518_108558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat_bubble_2",
    d: "M4 20V5.6C4 5.16 4.15667 4.78333 4.47 4.47C4.78333 4.15667 5.16 4 5.6 4H18.4C18.84 4 19.2167 4.15667 19.53 4.47C19.8433 4.78333 20 5.16 20 5.6V15.2C20 15.64 19.8433 16.0167 19.53 16.33C19.2167 16.6433 18.84 16.8 18.4 16.8H7.2L4 20ZM6.52 15.2H18.4V5.6H5.6V16.1L6.52 15.2Z",
    fill: "#1C1B1F"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessages, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/messages.93bb6d32.svg";
export { ForwardRef as ReactComponent };